import React, { useState } from "react";

const OTPInput = ({ length, onChange }) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // Keep only the last character
    setOtp(newOtp);
    onChange(newOtp.join(""));

    // Focus next input if value is entered
    if (value && index < length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && index > 0 && otp[index] === "") {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, length);
    const newOtp = pasteData
      .split("")
      .concat(new Array(length).fill(""))
      .slice(0, length);
    setOtp(newOtp);
    onChange(newOtp.join(""));
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        justifyContent: "center",
        marginTop: "8px",
      }}
    >
      {otp.map((_, index) => (
        <input
          key={index}
          id={`otp-input-${index}`}
          type="number"
          maxLength="1"
          value={otp[index]}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          className="otpinput"
          style={{
            width: "40px",
            height: "40px",
            textAlign: "center",
            fontSize: "20px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            outline: "none",
          }}
        />
      ))}
    </div>
  );
};

export default OTPInput;
